<template>
  <div>
    <el-table size="medium" stripe :data="biddings" style="width: 100%">
      <!--  -->
      <!--  -->
      <el-table-column align="center" label="#ID" width="60">
        <template #default="scope">
          <el-tooltip :content="scope.row._id">
            <i f-w-700 class="el-icon-money"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <!-- Business -->
      <el-table-column prop="Startup" label="Startup">
        <template #default="scope">
          <h4 f-w-600 m-tb-0>{{ scope.row.business.name }}</h4>
        </template>
      </el-table-column>
      <!--  -->
      <!-- Talent -->
      <el-table-column prop="Talent" label="Talent">
        <template #default="scope">
          <h4 f-w-600 m-tb-0>
            {{ scope.row.talent.firstName }}
            <span v-if="scope.row.talent.lastName">
              {{ scope.row.talent.lastName.charAt(0) }}
            </span>
          </h4>
        </template>
      </el-table-column>
      <!--  -->
      <!-- Compensation -->
      <el-table-column prop="compensation" label="Compensation" width="180">
        <template #default="scope">
          <el-tag size="mini" round>
            {{ $filters.capitalize(scope.row.compensationTypes.join(", ")) }}
          </el-tag>
        </template>
      </el-table-column>
      <!--  -->
      <!-- Compensation -->
      <el-table-column prop="compensationAmount" label="Amount" width="180">
        <template #default="scope">
          <span>
            <span v-if="scope.row.compensationTypes.includes('cash')">
              {{ scope.row.currency }}
              {{ scope.row.cash }}
            </span>
            <span v-if="scope.row.compensationTypes.includes('equity')">
              {{ scope.row.equity }} %
            </span>
          </span>
        </template>
      </el-table-column>
      <!--  -->
      <!-- status -->
      <el-table-column prop="status" label="Status" width="180">
        <template #default="scope">
          <el-tag size="mini" round>{{
            $filters.capitalize(scope.row.status)
          }}</el-tag>
        </template>
      </el-table-column>
      <!--  -->
      <!-- Actions -->
      <el-table-column align="center" label="Actions" width="120">
        <template #default>
          <el-button
            icon="el-icon-more"
            is-borderless
            circle
            plain
            size="small"
          />
        </template>
      </el-table-column>
      <!--  -->
    </el-table>
  </div>
</template>

<script lang="ts">
import { User } from "@/shared";
import { Options, Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Options({
  components: {},
})
export default class extends Vue {
  @Prop()
  biddings?: Array<User>;
}
</script>

<style lang="scss"></style>
